/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAppActiveProtectionIdsQueryVariables = Types.Exact<{
  appId: Types.Scalars['ID']['input'];
}>;

export type IAppActiveProtectionIdsQuery = {
  __typename?: 'Query';
  appProtections: Array<
    | { __typename?: 'Backup'; id: string }
    | { __typename?: 'ContinuityEscrow'; id: string }
    | { __typename?: 'CustodianProfile'; id: string }
    | { __typename?: 'SaasEscrow'; id: string }
    | { __typename?: 'SoftwareEscrow'; id: string }
  >;
};

export const AppActiveProtectionIdsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'appActiveProtectionIds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appProtections' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'appId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'appId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'statuses' },
                value: { kind: 'ListValue', values: [{ kind: 'EnumValue', value: 'active' }] },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAppActiveProtectionIdsQuery, IAppActiveProtectionIdsQueryVariables>;
